import { createStyledClone } from '@/services/print/svghelpers';
/* eslint-disable no-param-reassign */
// import chartTemplate from './PDFChartContainerTemplate';

export const noData = (
    metric,
    template = {}
) => {
    const { colour } = template;
    // const zoneComparisonLabel = {
    //     align: 'right',
    //     w: 'w-1-1/4',
    //     font: { colour: 'neutral.label' },
    //     text: `${metric.formatWithUnits(metric.zoneValue)} in Zone `,
    // };
    // const comparisonLabel = {
    //     display: 'inline',
    //     text: `| ${metric.formatWithUnits(metric.comparisonValue)} in ${metric.comparisonLabel}`,
    //     // x: 'w-1-1/2',
    //     font: { colour: 'print.strong' }
    // };
    const comparisonLabels = {
        // h: 'h-0-3/8',
        font: { size: 'md' },
        mb: 5,
        markdown: {
            bold: { colour: 'print.strong', weight: 'normal' },
            italic: { style: 'italic' }
        },
        text: `${metric.formatWithUnits(metric.zoneValue)} in Zone **| ${metric.formatWithUnits(metric.comparisonValue)} in ${metric.comparisonLabel}**`
    };
    const dataUnavailable = {
        text: `Data Unavailable for ${metric.valueLabelFull}`,
        font: { colour, size: 7 }
    };
    return {
        // h: 'h-1-1/2',
        // y: 'h-0-1/4',
        comparisonLabels,
        dataUnavailable
    };
};
export default (
    metric,
    template = {}
) => {
    const { chart = {} } = template;
    template.chart = template.chart || chart;
    const selector = `#${metric.id} svg:not(.content-placeholder):not(.svg-inline)`;
    // const template = chartTemplate(metric, { colour });
    if (!metric.value) {
        chart.noData = noData(metric, template);
        chart.h = chart.noData.h;
    } else {
        chart.svg = createStyledClone({ selector });
    }
    return template;
};
